



















import { Component, Vue } from 'vue-property-decorator';
import { Order } from '@/interfaces/order.interface';
import { namespace } from 'vuex-class';
import OrderForm from '@/components/OrderForm.vue';

const ordersModule = namespace('orders');

@Component({
  components: {
    OrderForm
  }
})
export default class OrderEditView extends Vue {
  @ordersModule.State orders!: Order[];
  @ordersModule.Action fetchOneOrder!: any;

  order: Order = {};

  async mounted() {
    const orderUuid = this.$route.params['orderUuid'];
    await this.fetchOneOrder({orderUuid});
    this.order = this.orders.find((o: Order) => o.uuid === orderUuid) || {};
  }
}
